import React, { useState } from 'react';
import './ChatWidget.css';
import asclepio from '../assets/img_roles/asclepio.jpg';
import { API_URL } from '../config.js'; 

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [mensajes, setMensajes] = useState([]);
  const [threadId, setThreadId] = useState(null); 

  const enviarMensaje = async () => {
    if (!mensaje.trim()) return;

    const texto = mensaje.trim();

    // 1) Pintamos el mensaje del usuario inmediatamente
    const userMsg = { role: 'user', content: texto };
    setMensajes((prev) => [...prev, userMsg]);
    setMensaje('');

    try {
      // 2) Llamamos al backend, que se encarga de hablar con OpenAI
      const res = await fetch(`${API_URL}/chat-widget`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: texto,
          threadId: threadId || null, // si existe, lo mandamos
        }),
      });

      if (!res.ok) {
        console.error('❌ Error HTTP en /chat-widget:', res.status);
        return;
      }

      const data = await res.json();

      // 3) El backend puede devolver un threadId para continuar la conversación
      if (data.threadId && !threadId) {
        setThreadId(data.threadId);
      }

      // 4) Pintamos la respuesta del asistente
      if (data.reply) {
        const assistantMsg = { role: 'assistant', content: data.reply };
        setMensajes((prev) => [...prev, assistantMsg]);
      }
    } catch (err) {
      console.error('❌ Error llamando a /chat-widget:', err);
    }
  };

  return (
    <div className="chat-bubble">
      <button className="chat-icon" onClick={() => setIsOpen(!isOpen)}>
        <img src={asclepio} alt="chat" />
      </button>

      {isOpen && (
        <div className="chat-window">
          <div className="chat-mensajes">
            {mensajes.map((m, i) => (
              <div key={i} className={`mensaje ${m.role}`}>
                <p>{m.content}</p>
              </div>
            ))}
          </div>
          <input
            type="text"
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && enviarMensaje()}
            placeholder="Escribe tu duda aquí..."
          />
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
